import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { Typography, InputLabel, InputAdornment, FormControl, OutlinedInput, ListItem } from '@mui/material';
// import RangeSlider from 'src/components/property/RangeSlider';
// import { BackdropLoader } from '@livable/saas-react-components';

export const AdminFee = observer(_ref => {
  var _store$addNewProperty, _store$addNewProperty2;
  let adminFee = _ref.adminFee,
    isLoaded = _ref.isLoaded;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState((_store$addNewProperty = store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName: 'adminFee'
    })) !== null && _store$addNewProperty !== void 0 && _store$addNewProperty.value ? (_store$addNewProperty2 = store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName: 'adminFee'
    })) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.value : null),
    _useState2 = _slicedToArray(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    amountTouched = _useState4[0],
    setAmountTouched = _useState4[1];
  const handleChange = e => {
    if (+e.target.value <= 99.99 && /^\d+([.,]\d{0,2})?$|^$/.test(+e.target.value)) {
      setAmount(e.target.value);
      store.addNewProperty.feeStructureV2.updateFee({
        feeName: 'adminFee',
        value: +e.target.value,
        feeUnitType: FEE_UNIT_TYPES.fixedAmount
      });
    }
  };
  useEffect(() => {
    var _store$addNewProperty3, _store$addNewProperty4;
    setAmount((_store$addNewProperty3 = store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName: 'adminFee'
    })) !== null && _store$addNewProperty3 !== void 0 && _store$addNewProperty3.value ? (_store$addNewProperty4 = store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName: 'adminFee'
    })) === null || _store$addNewProperty4 === void 0 ? void 0 : _store$addNewProperty4.value : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminFee, isLoaded]);

  // const rangeSliderHandleChange = (event, value) => {
  //   store.addNewProperty.feeStructureV2.updateFee({
  //     feeName: 'adminFee',
  //     value: maxValue - value,
  //     feeUnitType: FEE_UNIT_TYPES.fixedAmount,
  //   });

  //   store.addNewProperty.feeStructureV2.updateFee({
  //     feeName: 'unitSubscriptionFee',
  //     value: value,
  //     feeUnitType: FEE_UNIT_TYPES.fixedAmount,
  //   });
  // };

  // if (
  //   store.addNewProperty.feeStructureV2.getPropertyFee({
  //     feeName: 'unitSubscriptionFee',
  //   }) === null
  // ) {
  //   store.addNewProperty.feeStructureV2.updateFee({
  //     feeName: 'adminFee',
  //     value: 0,
  //     feeUnitType: FEE_UNIT_TYPES.fixedAmount,
  //   });

  //   store.addNewProperty.feeStructureV2.updateFee({
  //     feeName: 'unitSubscriptionFee',
  //     value: maxValue,
  //     feeUnitType: FEE_UNIT_TYPES.fixedAmount,
  //   });
  // }

  return /*#__PURE__*/React.createElement(ListItem, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.amf')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.amf_description'))), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: handleChange
    // error={amountTouched && amount === '0'}
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "resident-payment"
  }, t('add_new_property_flow.fee_value')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "resident-payment",
    label: t('add_new_property_flow.fee_value'),
    type: "number",
    value: amount,
    placeholder: "Not set",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    onBlur: () => {
      if (!amountTouched) setAmountTouched(true);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.caption
  }, t('add_new_property_flow.amf_caption'))));
});